import React, { FC } from 'react';
import './MatchingForm.css';
import {
	SelectField,
	RequiredNote,
	FaThumbsUp,
	DomainFormProps
} from '@/Shared';


/**
 * =====================================================
 * Component: MatchingForm
 * =====================================================
 *
 *
 * Domain-specific form UI for Matching.
 * Mounted inside GenericDomainForm.
 *
 * Responsibilities:
 * - Render matching fields
 * - Use data from formVM (options, values)
 *
 * No permissions, no loading, no orchestration logic here.
 *
 * Author: Samano CASTRE
 * Date: February 15, 2026
 */
const MatchingForm: FC<DomainFormProps> = ({
	domainFormHook,
	formRef,
}) => {

	const { entityFormVM } = domainFormHook;

	/**
	 * =====================================================
	 * Main Form Rendering
	 * =====================================================
	 *
	 * Fieldsets organize the form into logical sections for clarity.
	 */
	return (
		<div className="fieldset-wrapper">
			<fieldset>
				<legend>Résultat</legend>
				<SelectField
					label='Résultat du besoin'
					icon={<FaThumbsUp />}
					name='status'
					required
					options={entityFormVM.statusOptions}
					scrollParent={formRef.current}
					placeholder='Choisir le résultat'
				/>
				<RequiredNote />
			</fieldset>
		</div>
	);
}

export default MatchingForm;